module.exports = __webpack_public_path__ + "static/media/LOMVER_MENU-normal.2660b5db.png";